import { ServiceProviderType, YesNo } from "@/types/index";
import { FieldRow } from "../../../components/molecules/FieldsTable";
import { NotAvailable } from "../../Dashboard/RequestDetails/NotAvailable";
import { PersonDetails } from "./PersonDetails";
import { readableAccountNextSteps } from "@/utils/accounts";

export const CreditCardsAccount = ({
  account,
  serviceProviderType,
}: {
  account: any;
  serviceProviderType: ServiceProviderType;
}) => {
  return (
    <>
      <FieldRow
        label="Credit card number"
        value={account.accountNumber ? account.accountNumber : <NotAvailable />}
      />

      <FieldRow label="Joint policy?" value={account.jointClaim === YesNo.Yes ? "Yes" : "No"} />

      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(account.nextStep, serviceProviderType)}
      />

      <FieldRow
        label="Responsible"
        value={
          account?.responsible?.id === "notifier" ? (
            "Myself"
          ) : (
            <PersonDetails person={account?.responsible?.details} />
          )
        }
      />
    </>
  );
};
